import { Card } from '@iwoca/orion';

import { LinkWithQuery } from '../../../../components/LinkWithQuery/LinkWithQuery';
import chevronRight from '../../../../components/svg/ChevronRight.svg';
import { usePayLinks } from '../../../hooks/usePaylinks.hook';
import { PayLinkSource } from '../../../Payments/components/PayLinkTable/components/PayLinkSource/PayLinkSource';
import { PayLinkColumns } from '../../../Payments/components/PayLinkTable/PayLinkTable';
import { mapPayLinkStatusToFriendly } from '../../../Payments/components/PayLinkTable/utils/payLinkStatusMaps';
import { normalisePayLinkTableData } from '../../../Payments/utils/utils';

export const PaymentActivity = () => {
  const { payLinks } = usePayLinks({ orderBy: 'last_updated' });
  const normalisedPayLinks = normalisePayLinkTableData({
    payLinks: payLinks,
    selectedRows: [],
    handleRemoveSelectedRow: () => {},
    handleAddSelectedRow: () => {},
    sellerHandle: '',
  });

  // Endpoint doesn't support custom page sizes, for now we can just do this on FE
  const PAGE_SIZE = 5;

  return (
    <Card className="!block !p-0 !text-left">
      <div className="flex justify-between px-xl py-l max-600:inline-block">
        <div className="text-l font-bold text-primary-10 max-600:mb-l">
          Recent payment statuses
        </div>
        <LinkWithQuery
          className="flex items-center text-s font-bold text-primary-40 no-underline"
          to="/pay/payments/"
        >
          See all payments
          <img src={chevronRight} alt="arrow" />
        </LinkWithQuery>
      </div>
      <div>
        {normalisedPayLinks.slice(0, PAGE_SIZE).map((paylink) => (
          <PayLinkInfo key={paylink.paylink_id} paylink={paylink} />
        ))}
      </div>
    </Card>
  );
};

const PayLinkInfo = ({ paylink }: { paylink: PayLinkColumns }) => {
  return (
    <div
      key={`payment__${paylink.paylink_id}`}
      className="block border-t border-secondary-90 px-xl py-r"
    >
      <div className="flex justify-between">
        <div>
          <div className="mb-xs text-m font-med">{paylink.reference}</div>
          <div className="text-s font-med">{paylink.buyerName}</div>
        </div>
        <div className="text-right">
          <div className="text-m font-med">{paylink.amount}</div>
        </div>
      </div>
      <div className="flex items-end justify-between">
        <div className="text-s">
          {mapPayLinkStatusToFriendly(paylink.status)}
        </div>
        <div>
          <div className="text-right">
            <div className="text-s">
              <PayLinkSource
                payLink={paylink}
                className="!grid-cols-[18px_auto]"
              />
            </div>
            <div className="text-xs font-med">{paylink.date}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
